import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { actUserLogout } from "../../../../actions";

import LogoutModal from "../../../common/LogoutModal";
import classes from "./index.module.scss";

const getProfileName = (profileData) => {
  const firstName =
    profileData && profileData.first_name ? profileData.first_name : "";
  const lastName =
    profileData && profileData.last_name ? profileData.last_name : "";
  const combinedName = `${firstName} ${lastName}`.trim();
  return (profileData && profileData.name) || combinedName || "My Account";
};

const DashboardSidepanel = (props) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { pathname } = props.location;
  const { profile_data } = props;
  const profileName = getProfileName(profile_data);
  const profileEmail = (profile_data && profile_data.email) || "";
  const avatarInitial = (profileName || profileEmail || "A")
    .charAt(0)
    .toUpperCase();

  const menuItems = [
    {
      path: "/dashboard",
      label: "Dashboard",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="9" rx="1" />
          <rect x="14" y="3" width="7" height="5" rx="1" />
          <rect x="14" y="12" width="7" height="9" rx="1" />
          <rect x="3" y="16" width="7" height="5" rx="1" />
        </svg>
      ),
    },
    {
      path: "/my-orders",
      label: "My Orders",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
          <line x1="3" y1="6" x2="21" y2="6" />
          <path d="M16 10a4 4 0 0 1-8 0" />
        </svg>
      ),
    },
    {
      path: "/user/profile",
      label: "Edit Profile",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      ),
    },
    {
      path: "/change-password",
      label: "Change Password",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      ),
    },
  ];

  const logoutSubmit = () => {
    props.actUserLogout();
  };

  const getMenuClass = (path) =>
    `${classes.menu_item} ${pathname === path ? classes.menu_item_active : ""}`;

  return (
    <div>
      <div className="uk-padding-small">
        <div className={classes.profile_section}>
          <div className={classes.avatar}>{avatarInitial}</div>
          <div className={classes.profile_info}>
            <p className={classes.profile_name}>{profileName}</p>
            {profileEmail ? (
              <p className={classes.profile_email}>{profileEmail}</p>
            ) : null}
          </div>
        </div>
        <ul className={classes.sidepanel_list}>
          {menuItems.map((item) => (
            <li key={item.path} className={classes.list_item}>
              <Link
                to={`${process.env.PUBLIC_URL}${item.path}`}
                className={getMenuClass(item.path)}
                aria-current={pathname === item.path ? "page" : undefined}
              >
                <span className={classes.menu_icon}>{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
        <button
          type="button"
          className={classes.logout_btn}
          onClick={() => setShowLogoutModal(true)}
        >
          <span className={classes.menu_icon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </span>
          <span>Log Out</span>
        </button>
      </div>

      <LogoutModal
        open={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onLogout={logoutSubmit}
        modalClassName={classes.logout_modal_container}
        contentClassName={classes.logout_modal}
        actionsClassName={classes.modal_actions}
        confirmBtnClassName={classes.logout_confirm_btn}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile_data: state.data.profile_data,
});

export default withRouter(
  connect(mapStateToProps, { actUserLogout })(DashboardSidepanel),
);
